import React, { useState } from 'react';
import UniDropAdv from './ReportFormGenerator/UniDrop/UniDropAdv';
import liracrypt from './Liracrypt/liracrypt';
import ApiErrorComp from './ApiErrorComp/ApiErrorComp';
import { Col, Row, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import ZenFormInput from '../pages/InputCreater/ZenFormInput';


const SingleValDynamicDropdown = ({
    data,
    controlHeight,
    pageType,
    onChange,
    labelColSpan,
    form,
    colSpan,
    multiSelect,
    url,
    source,
    sourceParams,
    disabled,
    options,
    extraData,
    name,
    pname,
    label,
    required,
    placeHolder,
    searchable,
    includeAll,
    defaultValue,
    LocalDict
}) => {
    console.log(sourceParams);
    const [pageConfig, setPageConfig] = useState();
    const dtArray = ["datePicker", "rangePicker", "dateTimePicker", "timePicker"];

    const [loading, setLoading] = useState(false);
    const onDropdownChange = (val) => {
        setLoading(true);
        liracrypt.get(data.api, { ...data.params, [name]: val })
            .then(({ data }) => {
                setPageConfig(data);
                setLoading(false);

            }).catch(err => {
                ApiErrorComp();
                console.log(err);
            })
    }

    const queryElements = (x) => {
        return (
            <ZenFormInput
                pageType={pageType}
                childType={x.childType}
                labelColSpan={x["labelColSpan"]}
                style={x['style']}
                height={x['height']}
                layoutPosition="space-between"
                form={form}
                rows={x.rows}
                colSpan={x.colSize || 12}
                name={x["data_index"]}
                label={x["label"]}
                defaultValue={x["default"]}
                typ={x["typ"]}
                disabled={x["readOnly"]}
                source={x["source"]}
                sourceParams={x["sourceParams"]}
                auxParams={x["auxParams"]}
                format={x["format"]}
                errorMessage={x["errorMessage"]}
                placeHolder={x["placeHolder"]}
                required={x["required"]}
                options={x["data"]}
                from={x["data_index_from"]}
                to={x["data_index_to"]}
                url={x["url"]}
                includeAll={x["includeAll"]}
                pname={x["p_data_index"]}
                defaultFrom={x["defaultFrom"]}
                defaultTo={x["defaultTo"]}
                multiSelect={x["multiSelect"]}
                searchable={x["isSearchable"]}
                data={x}
                // extraData={extraData}
                children={x['children']}
            />
        )
    }

    return (
        <>
            <Col span={colSpan}>
                <UniDropAdv
                    minSearchLength={data.minSearchLength || 3}
                    controlHeight={controlHeight}
                    onChange={onDropdownChange}
                    labelCol={labelColSpan ? labelColSpan : 8}
                    bg="transparent"
                    form={form}
                    colSpan={colSpan ? colSpan : 12}
                    multiSelect={multiSelect}
                    url={
                        url
                            ? url
                            : source === "mdict"
                                ? "/mdict"
                                : source === "usergroup"
                                    ? "/usergroup"
                                    : source === "cropdown"
                                        ? "/cropdown"
                                        : source === "dynamic"
                                            ? "/dynamicDropdown"
                                            : ""
                    }
                    disabled={disabled}
                    onChangeConfMsg={data.onChangeConfMsg}
                    source={source}
                    options={options}
                    extraData={extraData}
                    urlData={sourceParams ? sourceParams : {}}
                    pname={pname ? pname : `p${name}`}
                    name={name}
                    label={label}
                    errorMessage={"Please Select " + label}
                    required={required}
                    placeholder={placeHolder}
                    defaultValue={defaultValue ? defaultValue : null}
                    includeAll={includeAll ? includeAll : false}
                    searchable={searchable ? searchable : false}
                />
            </Col>
            {
                loading ?
                    <div style={{ display: 'inline-flex', justifyContent: 'center', alignItems: 'center', width: '100%', padding: 20 }}>
                        <Spin indicator={<LoadingOutlined style={{ fontSize: 30 }} />} />
                    </div> :
                    <>
                        {
                            (pageConfig?.config?.modalElements?.length) ?
                                pageConfig?.config?.modalElements?.map((x, index) => {
                                    if (dtArray.includes(x["typ"])) {

                                        LocalDict[x["data_index"]] = x["format"]
                                            ? x["format"]
                                            : "YYYY-MM-DD hh:mm:ss";
                                        LocalDict["data_index_from"] = x["data_index_from"];
                                        LocalDict["data_index_to"] = x["data_index_to"];
                                    }
                                    return (
                                        <>
                                            {
                                                pageType === 'zenForm' ?
                                                    <>{queryElements(x)}</> :
                                                    <Col span={24}>
                                                        <Row justify={"center"} key={index}>
                                                            {queryElements(x)}
                                                        </Row>
                                                    </Col>
                                            }

                                        </>
                                    )
                                }) : <></>
                        }
                    </>
            }

        </>
    )
};

export default SingleValDynamicDropdown;